<script setup lang="ts">
import { ref } from 'vue';
import PrimaryButton from '@/components/general/PrimaryButton.vue';
import PasswordInput from '@/components/general/PasswordInput.vue';
import { ROUTES } from '@/router/routeNames';
import { useAuthStore } from '@/stores/authStore';
import { useFormValidation } from '@/composables/useFormValidation';
import { loginSchema } from '@/formValidationschemas';
import { useField } from 'vee-validate';
import { useToast } from 'primevue/usetoast'
const toast = useToast()
const authStore = useAuthStore()
const { handleSubmit, errors } = useFormValidation(loginSchema)
const { error, mutate, isPending } = authStore.login()

const form = ref({
    email: '',
    password: '',
    remember: false,
});


const { value: email } = useField('email') as any
const { value: password } = useField('password') as any
const submit = handleSubmit((values) => {
    mutate(values as {
        email: string;
        password: string;
    })
    // form.post(route('login'), {
    //     onSuccess: () => {
    //         // Handle successful login
    //     },
    //     onError: (errors) => {
    //         if (errors.email) {
    //             toast.value.addToast(errors.email, 'error');
    //         }
    //     }
    // });
});

watchEffect(() => {
    if (error.value) {
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: error.value.response?.data.message,
        life: 3000
      });
    }
})
</script>

<template>
    <div class="flex flex-col justify-center items-center px-4">
        <!-- Logo/Brand -->
        <Router-Link :to="{ name: ROUTES.HOME }" class="mb-8">
            <h1 class="text-4xl font-black text-green-600">BoxBuddy</h1>
        </Router-Link>

        <!-- Login Card -->
        <div class="p-8 w-full max-w-md bg-white rounded-2xl shadow-lg">
            <h2 class="mb-6 text-2xl font-bold text-gray-900">Welcome back</h2>

            <!-- <div v-if="status" class="mb-4 text-sm font-medium text-green-600">
                {{ status }}
            </div> -->

            <form @submit.prevent="submit">
                <div class="space-y-6">
                    <!-- Email -->
                    <div>
                        <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
                        <input
                            id="email"
                            v-model="email"
                            type="email"
                            required
                            autocomplete="email"
                            class="block px-4 py-3 w-full text-gray-900 rounded-xl border-0 ring-1 ring-inset ring-gray-300 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                        <span class="text-sm text-red-800">{{ errors.email }}</span>
                    </div>

                    <!-- Password -->
                    <div>
                        <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
                        <PasswordInput
                            id="password"
                            v-model="password"
                            required
                            autocomplete="current-password"
                            placeholder="Enter your password"
                        />
                        <span class="text-sm text-red-800">{{ errors.password }}</span>
                    </div>

                    <!-- Remember Me -->
                    <div class="flex justify-between items-center">
                        <label class="flex items-center">
                            <input
                                v-model="form.remember"
                                type="checkbox"
                                class="w-4 h-4 text-green-600 focus:ring-green-500"
                            />
                            <span class="ml-2 text-sm text-gray-600">Remember me</span>
                        </label>

                        <Router-Link
                            :to="{ name: ROUTES.FORGOTPASSWORD }"
                            class="text-sm font-medium text-green-600 hover:text-green-500"
                        >
                            Forgot password?
                        </Router-Link>
                    </div>

                    <div>
                        <PrimaryButton
                            type="submit"
                            :disabled="isPending"
                            class="justify-center w-full"
                        >
                            <span v-if="isPending" class="mr-2">
                                <i class="pi pi-spin pi-spinner"></i>
                            </span>
                            Log in
                        </PrimaryButton>
                    </div>
                </div>
            </form>

            <div class="mt-6 text-center">
                <span class="text-sm text-gray-600">Don't have an account?</span>
                <Router-Link
                    :to="{ name: ROUTES.REGISTER }"
                    class="ml-1 text-sm font-medium text-green-600 hover:text-green-500"
                >
                    Sign up
                </Router-Link>
            </div>
        </div>
    </div>
</template>
